<template>
  <footer class="bg-custom text-white text-center text-lg-start">
    <!-- Grid container -->
    <div class="container p-4">
      <!--Grid row-->
      <div class="row">
        <!--Grid column-->
        <div class="col-lg-6 col-md-12 mb-4 mt-4 mb-md-0">
          <img src="../../assets/yourlogo.png" alt="YOUR LOGO" />
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
          <h5 class="text-uppercase">YOURSERVERNAME</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a href="#!" class="text-white">Download</a>
            </li>
            <li>
              <a href="#!" class="text-white">Hiscores</a>
            </li>
            <li>
              <a href="#!" class="text-white">Store</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
          <h5 class="text-uppercase mb-0">Community</h5>

          <ul class="list-unstyled mt-2">
            <li>
              <a href="#!" class="text-white">Forums</a>
            </li>
            <li>
              <a href="#!" class="text-white">Discord</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->
    </div>
    <!-- Grid container -->

    <!-- Copyright -->
    <div class="text-center p-3 bg">
      © 2022 Copyright:
      <a class="text-white" href="#">yourserver.com</a>
    </div>
    <!-- Copyright -->
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
.bg-custom {
  background-color: rgba(0, 0, 0, 0.479);
}
.bg {
  background-color: rgba(0, 0, 0, 0.2);
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (max-width: 600px) {
  img {
    width: 100%;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
</style>